import { useEffect, useState } from "react";

const items = [
  { id: "about", label: "01 ABOUT", target: "scene-about" },
  { id: "stack", label: "02 STACK", target: "scene-index" },
  { id: "work", label: "03 WORK", target: "scene-work" },
  { id: "contact", label: "04 CONTACT", target: "scene-cta" },
];

export default function Nav() {
  const [theme, setTheme] = useState<"dark" | "paper" | "signal">("dark");
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      const doc = document.documentElement;
      const p = doc.scrollTop / (doc.scrollHeight - window.innerHeight || 1);
      setProgress(Math.max(0, Math.min(1, p)));

      const bp = document.querySelector<HTMLElement>("[data-theme]:not(.hidden-theme)");
      // Determine current theme by scanning theme regions
      const zones = Array.from(document.querySelectorAll<HTMLElement>("[data-theme]"));
      const mid = window.innerHeight / 2;
      for (const z of zones) {
        const rect = z.getBoundingClientRect();
        if (rect.top <= mid && rect.bottom >= mid) {
          const t = z.dataset.theme as "dark" | "paper" | "signal";
          setTheme(t);
          break;
        }
      }
      // silence unused
      void bp;
      raf = requestAnimationFrame(update);
    };
    raf = requestAnimationFrame(update);
    return () => cancelAnimationFrame(raf);
  }, []);

  const jump = (target: string) => {
    const el = document.getElementById(target);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  const isPaper = theme === "paper";
  const isSignal = theme === "signal";
  const fg = isSignal ? "#090A0A" : isPaper ? "#090A0A" : "#FFFFFF";
  const muted = isSignal ? "#222422" : isPaper ? "#5a5a52" : "#B8B8B0";

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 pointer-events-none"
      aria-label="Primary"
    >
      <div className="pointer-events-auto flex items-center justify-between px-6 md:px-10 py-5 type-mono text-[11px] tabular">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 cursor-pointer whitespace-nowrap"
          style={{ color: fg }}
        >
          <span
            className="type-display text-[16px] leading-none"
            style={{ color: fg }}
          >
            R
          </span>
          <span className="hidden md:inline" style={{ color: muted }}>REMI / AI</span>
        </button>

        <ul className="hidden md:flex items-center gap-8" style={{ color: fg }}>
          {items.map((it) => (
            <li key={it.id}>
              <button
                onClick={() => jump(it.target)}
                className="cursor-pointer hover:opacity-60 transition-opacity whitespace-nowrap"
              >
                {it.label}
              </button>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-4 whitespace-nowrap" style={{ color: muted }}>
          <span className="tabular">{String(Math.round(progress * 100)).padStart(3, "0")}</span>
          <span className="hidden md:inline">SHIPPING NOW</span>
        </div>
      </div>

      <div
        className="h-[1px] w-full origin-left"
        style={{
          transform: `scaleX(${progress})`,
          background: isSignal ? "#090A0A" : isPaper ? "#090A0A" : "#FF5A1F",
          opacity: 0.6,
        }}
      />
    </nav>
  );
}